
import posthog from 'posthog-js';

/**
 * Initialize PostHog with the provided API key and host URL
 * This should be called once at the application startup
 */
export const initPostHog = () => {
  // Only initialize in production to avoid tracking development activity
  if (import.meta.env.PROD) {
    posthog.init(
      import.meta.env.VITE_POSTHOG_API_KEY || '',
      {
        api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.posthog.com',
        capture_pageview: true, // Automatically capture pageviews
        capture_pageleave: true, // Capture when users leave the page
        loaded: (posthog) => {
          console.log('PostHog loaded successfully');
        }
      }
    );
    console.log('PostHog initialized in production mode');
  } else {
    console.log('PostHog disabled in development mode');
  }
};

/**
 * Track a custom event with optional properties
 */
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (import.meta.env.PROD) {
    posthog.capture(eventName, properties);
  } else {
    console.log(`[DEV] PostHog event tracked: ${eventName}`, properties);
  }
};

/**
 * Identify a user with their ID and optional properties
 */
export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (import.meta.env.PROD) {
    posthog.identify(userId, properties);
  } else {
    console.log(`[DEV] PostHog user identified: ${userId}`, properties);
  }
};

export default posthog;
